import Text from "./Text";
import { useNavigate } from "react-router-dom";
import TIcon from "./TIcon";

export default function ContentCard({ title, description, children, classNames = "flex flex-row gap-2", link = null, baseClases = "bg-gray-100 border-gray-300 border w-full shadow-md rounded-lg p-6", iconName = null }) {
    const navigate = useNavigate();

    const handleLinkClick = () => {
        if (link) {
            navigate(link);
        }
    };

    return (
        <div className={`${baseClases} ${classNames}` + (link ? " cursor-pointer hover:bg-gray-200 transition-colors" : "")} onClick={handleLinkClick}>
            {iconName && <TIcon size={48} name={iconName} className="text-2xl mb-2" />}
            <div className="flex flex-col gap-2">
                <Text type="maintitle" classNames="mb-2">{title}</Text>
                <Text type="body" classNames="mb-4">{description}</Text>
                {children}
            </div>

        </div>
    );
}